import { useState } from 'react';

import {
  SearchBarRangeDatePicker,
  SearchBarSingleDatePicker,
} from '@components/views/flight/listing/SearchBar/DateSelectNext/DateSelect';
import { FlightTripType } from '@components/views/flight/types';
import { DateType } from '@utils/dateUtil';

import { BookerSearchBarDateRangeInputWrapper } from './styled';

interface Dates {
  startDate?: DateType | null;
  endDate?: DateType | null;
}

interface Props {
  tripType: FlightTripType;
  initialDates?: Dates;
  dateChange: (dates?: Dates) => void;
  error?: boolean;
  isBookerSearch?: boolean;
  isHoliday?: boolean;
}

const BookerFlightDatePicker = ({
  tripType,
  dateChange,
  initialDates,
  error,
  isBookerSearch,
  isHoliday,
}: Props) => {
  const [localStartDate, setLocalStartDate] = useState<DateType | null>(
    initialDates?.startDate || null
  );
  const [localEndDate, setLocalEndDate] = useState<DateType | null>(
    initialDates?.endDate || null
  );

  const onDatesChange = ({
    startDate,
    endDate,
  }: {
    startDate: DateType | null;
    endDate: DateType | null;
  }) => {
    setLocalStartDate(startDate);
    setLocalEndDate(endDate);
    if (startDate && endDate) dateChange({ startDate, endDate });
  };

  const onDateChange = (date: moment.Moment | null) => {
    setLocalStartDate(date);
    dateChange({ startDate: date });
  };
  return (
    <BookerSearchBarDateRangeInputWrapper>
      {tripType === 'one-way' ? (
        <SearchBarSingleDatePicker
          date={localStartDate}
          onDateChange={onDateChange}
          error={error} // TODO:check the required functionality
          isBookerSearch={isBookerSearch}
          isHolidays={isHoliday}
        />
      ) : null}
      {tripType === 'round-trip' ? (
        <SearchBarRangeDatePicker
          minimumNights={0}
          startDate={localStartDate}
          endDate={localEndDate}
          onDatesChange={onDatesChange}
          error={error}
          isBookerSearch={isBookerSearch}
          isHolidays={isHoliday}
        />
      ) : null}
    </BookerSearchBarDateRangeInputWrapper>
  );
};
export default BookerFlightDatePicker;
